import { action, observable } from 'mobx';

// Utilities
import { push, identify } from 'utilities/woopra';

// Services
import { INetwork, IPerson, networkInitialize } from '../services/network';
import { IGetTaxonomyResponse, getTaxonomy } from '../services/tag';

// Types
type ITaxonomyData = IGetTaxonomyResponse;

// Store
class NetworkStore {
  @observable network: INetwork | null = null;
  @observable person: IPerson | null = null;
  @observable.ref taxonomy: ITaxonomyData | null = null;

  @action
  async initializeNetwork(networkId: string, analytics: boolean = false) {
    const { network, person } = await networkInitialize({
      params: { networkId }
    });
    this.network = network;
    this.person = person;
    if (analytics) {
      identify({
        id: person.userId,
        email: person.email,
        name: `${person.firstName} ${person.lastName}`,
        avatar: person.photoUrl || undefined,
        company: network.name
      });
      push();
    }
  }

  @action
  async getTaxonomy() {
    if (this.network !== null) {
      this.taxonomy = await getTaxonomy({
        params: { networkId: this.network!.networkId }
      });
    }
  }

  @action
  async resetTaxonomy() {
    this.taxonomy = null;
  }

  @action
  reset() {
    this.network = null;
    this.taxonomy = null;
    this.person = null;
  }
}
export { INetwork };
export type INetworkStore = NetworkStore;
export default NetworkStore;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/store/NetworkStore.ts